export const AUTHENTICATED_APP_PATH_PREFIXES = [
	'/calendar',
	'/dashboard',
	'/instrument',
	'/news',
	'/notifications',
	'/portfolios',
	'/screener',
	'/user',
	'/watchlists',
] as const;

export function isAuthenticatedAppPath(pathname: string): boolean {
	return AUTHENTICATED_APP_PATH_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
}
